<template>
  <div class="coupon-transfer flex">
    <div class="flex item-center">
      <!-- 左边 -->
      <div class="transfer divide">
        <div class="flex transfer-header flex-center">
          <div class="select flex-2 text-center">
            <el-checkbox
              :indeterminate="leftIsIndeterminate"
              :disabled="isPreview || leftData.length <= 0"
              v-model="leftCheckAll"
              @change="handleLeftCheckAllChange"
              style="float: left"
              >全选</el-checkbox
            >
            <span class="leftName">{{ leftName }}</span>
          </div>
        </div>
        <div class="transfer-body">
          <div class="divide-header">
            <span class="guider flex-1">机构</span>
            <span class="guider-id flex-1">职员</span>
            <span class="activity flex-1">工号</span>
          </div>
          <el-checkbox-group
            :disabled="isPreview"
            v-model="leftChecked"
            @change="handleLeftCheckedChange"
          >
            <div
              v-for="(v, i) in leftData"
              :key="i"
              class="check-wrapper flex item-center"
            >
              <el-checkbox class="flex" :label="v">
                <span :title="v.departName" class="wid100 text-overflow-2">
                  {{ v.departName }}
                </span>
                <span class="text-overflow-2 wid100">{{ v.memberName }} </span>
                <span>
                  {{ v.workNum }}
                </span>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="flex flex-column control text-center">
      <div>操作</div>
      <div class="transfer-switch">
        <el-switch
          size="mini"
          v-if="transferPage === 'examineGroup'"
          v-model="identity"
          active-text="考评人"
          inactive-text="被考核人"
          active-value="master"
          inactive-value="subordinate"
          active-color="#4680ff"
          inactive-color="#000"
        ></el-switch>
      </div>
      <el-button
        size="small"
        class="hmicon icon-youshuangjiantou"
        @click="allToRight"
        :disabled="leftData.length <= 0 || isPreview"
      ></el-button>
      <el-button
        size="small"
        class="hmicon icon-youjiantou"
        @click="toRight"
        :disabled="leftData.length <= 0 || leftChecked.length <= 0 || isPreview"
      ></el-button>
      <el-button
        size="small"
        class="hmicon icon-zuoshuangjiantou"
        @click="allToLeft"
        :disabled="rightData.length <= 0 || isPreview"
      ></el-button>
      <el-button
        size="small"
        class="hmicon icon-mjiantou-copy"
        @click="toLeft"
        :disabled="
          rightData.length <= 0 || rightChecked.length <= 0 || isPreview
        "
      ></el-button>
      <el-button
        size="small"
        class="hmicon icon-mjiantou-copy delete-selected"
        @click="deleteChecked"
        :disabled="
          leftChecked.length <= 0 || rightData.length <= 0 || isPreview
        "
      >
        剔除
        <el-tooltip
          class="item"
          effect="dark"
          content="剔除右侧列表和左侧已勾选的相同的选项"
          placement="top-end"
        >
          <i class="hmicon icon-wenhao"></i>
        </el-tooltip>
      </el-button>
    </div>
    <!-- 右边 -->
    <div class="transfer divide">
      <div
        class="flex transfer-header flex-center text-center"
        :class="background"
        style="padding: 15px"
      >
        <div class="select flex-2" style="padding: 0">
          <el-checkbox
            :indeterminate="rightIsIndeterminate"
            :disabled="isPreview || rightData.length <= 0"
            v-model="rightCheckAll"
            @change="handleRightCheckAllChange"
            style="float: left"
            >全选</el-checkbox
          >
          <span class="rightName">{{ rightName }}</span>
        </div>
      </div>
      <div class="transfer-body right">
        <div class="divide-header">
          <span class="coupon-type flex-1">机构</span>
          <span class="coupon-name flex-1">职员</span>
          <span class="coupon-name flex-1" v-if="identity">角色</span>
          <span class="coupon-target flex-1">工号</span>
        </div>
        <el-checkbox-group
          :disabled="isPreview"
          v-model="rightChecked"
          @change="handleRightCheckedChange"
        >
          <template v-if="identity">
            <div
              v-for="(v, i) in rightData.filter(v => v.identity === 'master')"
              :key="i"
              class="check-wrapper flex master"
            >
              <el-checkbox :label="v" class="devide-body flex">
                <span
                  class="text-overflow-2 wid100 text"
                  :title="v.departName"
                  >{{ v.departName }}</span
                >
                <span class="text-overflow-2 wid100 member-name text">{{
                  v.memberName
                }}</span>
                <span class="text"> 考评人 </span>
                <span class="text">{{ v.workNum }}</span>
              </el-checkbox>
            </div>
            <div
              v-for="(v, i) in rightData.filter(
                v => v.identity === 'subordinate'
              )"
              :key="'i' + i"
              class="check-wrapper flex subordinate"
            >
              <el-checkbox :label="v" class="devide-body flex">
                <span
                  class="text-overflow-2 wid100 text"
                  :title="v.departName"
                  >{{ v.departName }}</span
                >
                <span class="text-overflow-2 wid100 member-name text"
                  >{{ v.memberName }}
                </span>
                <span class="text"> 被考核人 </span>
                <span class="text">{{ v.workNum }}</span>
              </el-checkbox>
            </div>
          </template>
          <template v-else>
            <div
              v-for="(v, i) in rightData"
              :key="i"
              class="check-wrapper flex"
            >
              <el-checkbox :label="v" class="devide-body flex">
                <span class="text-overflow-2 wid100" :title="v.departName">{{
                  v.departName
                }}</span>
                <span class="text-overflow-2 wid100">{{ v.memberName }}</span>
                <span>{{ v.workNum }}</span>
              </el-checkbox>
            </div>
          </template>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    transferPage: {
      type: String,
      default: () => ""
    },
    background: { type: String },
    leftName: { type: String },
    rightName: { type: String },
    leftOption: { type: Array },
    transferMode: { type: String },
    isPreview: { type: Boolean },
    notValid: { type: Boolean },
    onlySelectOne: { type: Boolean }
  },
  data() {
    return {
      leftCheckAll: false,
      leftChecked: [],
      leftData: [],
      leftIsIndeterminate: false,
      rightCheckAll: false,
      rightChecked: [],
      rightData: [],
      rightIsIndeterminate: false,
      isEnableSession: false,
      sendWayType: "",
      identity: "master"
    };
  },
  computed: mapState({
    isEnableButton: state => state.rules.isEnableButton
  }),
  watch: {
    leftOption(val) {
      this.leftData = val;
      this.$forceUpdate();
    },
    rightChecked(val) {
      if (this.rightName === "给下列职员发放优惠券") {
        this.$store.commit("queryIsEnable", val.length > 0);
      }
    }
  },
  methods: {
    handleLeftCheckAllChange(val) {
      // 选择左边的全选
      this.leftChecked = val ? this.leftData : [];
      this.leftIsIndeterminate = false;
    },
    handleLeftCheckedChange(value) {
      // 选择左边的checkbox
      let checkedCount = value.length;
      this.leftCheckAll = checkedCount === this.leftData.length;
      this.leftIsIndeterminate =
        checkedCount > 0 && checkedCount < this.leftData.length;
    },
    handleRightCheckAllChange(val) {
      // 选择右边的全选
      this.rightChecked = val ? this.rightData : [];
      this.rightIsIndeterminate = false;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    handleRightCheckedChange(value) {
      // 选择右边的checkbox
      let checkedCount = value.length;
      this.rightCheckAll = checkedCount === this.rightData.length;
      this.rightIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rightData.length;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    allToRight() {
      // 移动所有到右边
      if (this.identity) {
        this.leftData.forEach(v => {
          v.identity = this.identity;
        });
      }
      const result = this.checkCommon(this.leftData, this.rightData);
      if (!result) {
        if (this.leftData.length > 0) {
          this.rightData = this.rightData.concat(this.leftData);
          this.leftData = [];
          this.leftChecked = [];
        }
        this.handleRightCheckAllChange(true);
        this.leftCheckAll = false;
        this.rightCheckAll = true;
      }
    },
    toRight() {
      // 移动选中到右边
      if (this.identity) {
        this.leftChecked.forEach(v => {
          v.identity = this.identity;
        });
      }
      const result = this.checkCommon(this.leftChecked, this.rightData);
      if (!result) {
        this.rightData = this.rightData.concat(this.leftChecked);
        if (this.leftChecked.length === this.leftData.length) {
          this.leftData = [];
        } else if (this.leftChecked.length === 1) {
          this.leftData.forEach((v, i) => {
            if (v.employeeId === this.leftChecked[0].employeeId) {
              this.leftData.splice(i, 1);
            }
          });
        } else {
          this.leftChecked.forEach(v => {
            this.leftData.forEach((item, index) => {
              if (v.employeeId === item.employeeId) {
                this.leftData.splice(index, 1);
              }
            });
          });
        }
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
        this.handleRightCheckAllChange(true);
        this.rightCheckAll = true;
      }
    },
    allToLeft() {
      // 移动所有到左边
      const result = this.checkCommon(this.rightData, this.leftData);
      if (!result) {
        this.rightCheckAll = false;
        this.rightIsIndeterminate = false;
        if (this.rightData.length > 0) {
          this.leftData = this.leftData.concat(this.rightData);
          this.rightData = [];
          this.rightChecked = [];
        }
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    toLeft() {
      // 移动选中到左边
      const result = this.checkCommon(this.rightChecked, this.leftData);
      if (!result) {
        this.leftData = this.leftData.concat(this.rightChecked);
        if (this.rightChecked.length === this.rightData.length) {
          this.rightData = [];
          this.rightChecked = [];
          this.rightCheckAll = false;
        } else if (this.rightChecked.length === 1) {
          this.rightData.forEach((v, i) => {
            if (v.employeeId === this.rightChecked[0].employeeId) {
              this.rightData.splice(i, 1);
            }
          });
          this.rightChecked = [];
        } else {
          this.rightChecked.forEach(v => {
            this.rightData.forEach((item, index) => {
              if (v.employeeId === item.employeeId) {
                this.rightData.splice(index, 1);
              }
            });
          });
        }
        this.rightChecked = [];
        this.rightIsIndeterminate = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    deleteChecked() {
      // 剔除右边和左边相同的
      if (this.leftChecked.length > 0) {
        this.leftChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v.name === item.name) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightCheckAll = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    toMinus(i, disabled) {
      // 减少数量
      if (!disabled && !this.onlySelectOne) {
        this.rightData[i].num--;
      }
    },
    toPlus(i, disabled, isEnableButton) {
      // 增加数量
      if ((isEnableButton || !disabled) && !this.onlySelectOne) {
        this.rightData[i].num++;
      }
    },
    checkCommon(checkedData, data) {
      let result = false;
      checkedData.forEach(v => {
        result =
          data.findIndex(o => {
            if (this.identity) {
              return v.employeeId === o.employeeId && v.identity === o.identity;
            }
            return v.employeeId === o.employeeId;
          }) !== -1;
      });
      if (result) {
        this.$message({
          message: "同一角色职员不能重复",
          type: "warning"
        });
      }
      return result;
    }
  }
};
</script>
<style lang="scss">
.devide-body {
  .el-checkbox__label {
    display: flex;
    align-items: center;
    flex: 1;
  }
}
</style>
<style lang="scss" scoped>
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  min-width: 380px;
  border-radius: 5px;
}
.transfer-header {
  padding: 15px;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.transfer-body {
  padding: 15px;
  border-radius: 0 0 5px 5px;
  height: 380px;
  overflow-y: scroll;
}
.control {
  margin: 0 15px;
  .el-button {
    margin: 0.5rem;
  }
}
.coupon-type,
.coupon-count,
.check-wrapper {
  height: 2rem;
  font-size: 14px;
}
.delete-selected {
  position: relative;
  .hmicon icon-wenhao {
    position: absolute;
    right: -7px;
    top: -7px;
    font-size: 1.2rem;
    color: #4680ff;
  }
}
.checkbox-group-wrapper {
  border-left: 1px solid #e7e8ec;
  border-right: 1px solid #e7e8ec;
  padding: 0 0.5rem;
}

input[type="number"] {
  width: 2rem;
  border: none;
  outline: none;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.leftName,
.rightName {
  margin-left: -52px;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.minus,
.plus {
  transition: background 0.2s linear;
  cursor: pointer;
}
.disabled {
  color: rgb(220, 223, 230);
  cursor: not-allowed;
}

.divide {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 15px;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }
  .el-checkbox__label {
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }

  .check-wrapper {
    margin: 15px 0;
  }
}

.transfer-body {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 15px;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    .count {
      width: 56px;
    }
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .coupon-name.flex1 {
      flex: 1;
      -webkit-flex: 1;
    }
    .devide-type {
      span {
        padding-right: 0.5rem;
      }
    }
  }
  &.right {
    .check-wrapper {
      &.master {
        .text {
          color: #4680ff;
        }
      }
      &.subordinate {
        .text {
          color: #606266;
        }
      }
    }
  }
  .check-wrapper {
    margin: 15px 0;
  }
  .devide-body {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .devide-body {
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .coupon-type {
      display: flex;
      align-items: center;
    }
  }

  .depart-name {
  }

  .wid100 {
    width: 100px;
  }
}
</style>
